module.exports = __webpack_public_path__ + "static/media/info-mail.59079f70.svg";